"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleMapLocationSaga = exports.onDomLoaded = exports.setMapType = exports.initAllGoogleMap = exports.initOneGoogleMap = exports.getMapsInDom = exports.getGoogleApiKey = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("../actions/GlobalAction");
var googlemapStyle_1 = require("@/pages/common/states/googlemapStyle");
var getGoogleApiKey = function (state) { return state.layout.googleApi; };
exports.getGoogleApiKey = getGoogleApiKey;
var getMapsInDom = function () {
    return __generator(this, function (_a) {
        if (!document)
            return [2 /*return*/];
        return [2 /*return*/, document.getElementsByClassName('google-map-location')];
    });
};
exports.getMapsInDom = getMapsInDom;
var initOneGoogleMap = function (mapElement) {
    var latLng = {
        lat: Number(mapElement.getAttribute('datalat')),
        lng: Number(mapElement.getAttribute('datalng')),
    };
    var name = mapElement.getAttribute('dataname');
    var mapTypeStr = mapElement.getAttribute('datamaptype');
    var map = new google.maps.Map(mapElement, {
        center: latLng,
        zoom: 17,
        styles: googlemapStyle_1.mapStyles,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        clickableIcons: false,
        gestureHandling: 'cooperative',
        mapTypeId: mapTypeStr,
    });
    var marker = new google.maps.Marker({
        map: map,
        position: latLng,
        title: name,
    });
    var infoWindow = new google.maps.InfoWindow({
        content: "<div class=\"c-map-info\">" + name + "</div>",
    });
    infoWindow.open(map, marker);
    return map;
};
exports.initOneGoogleMap = initOneGoogleMap;
var initAllGoogleMap = function () {
    var maps, i, map, id, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, effects_1.call(getMapsInDom)];
            case 1:
                maps = _c.sent();
                if (!maps)
                    return [2 /*return*/];
                i = 0;
                _c.label = 2;
            case 2:
                if (!(i < maps.length)) return [3 /*break*/, 5];
                map = maps[i];
                id = map.getAttribute('id');
                _a = window.maps;
                _b = id;
                return [4 /*yield*/, effects_1.call(initOneGoogleMap, map)];
            case 3:
                _a[_b] = _c.sent();
                _c.label = 4;
            case 4:
                i = i + 1;
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
};
exports.initAllGoogleMap = initAllGoogleMap;
var setMapType = function (id, type) {
    var map = window.maps[id];
    map.setMapTypeId(type);
};
exports.setMapType = setMapType;
var onDomLoaded = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.googleMapReady())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(initAllGoogleMap)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.onDomLoaded = onDomLoaded;
var googleMapLocationSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                window.maps = {};
                return [4 /*yield*/, effects_1.all([
                        effects_1.call(onDomLoaded),
                    ])];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.googleMapLocationSaga = googleMapLocationSaga;
